import { render, staticRenderFns } from "./VideoBackground.vue?vue&type=template&id=232da65e&scoped=true&"
import script from "./VideoBackground.vue?vue&type=script&lang=js&"
export * from "./VideoBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232da65e",
  null
  
)

export default component.exports